import React,{ useState , useEffect, useCallback} from 'react';
import SubHeader from '../components/SubHeader';
import config from '../appconfig/config.json';
import headerImg from '../hybridImages/PStepper3.png'; 
import FormContainer from '../components/FormContainer';
import { Field, FieldWrapper, Form, FormElement } from '@progress/kendo-react-form';
import { CusFormCalenInput, CusFormComboBox, CusFormCurrencyNew, CusFormInput, CusFormNumericTextBox, FormComboBox, FormDropDownList, FormDropDownList2, FormInput, FormNumericTextBox, FormTitleHybrid, FormTitleTooltip, HFormInput, HybridFormLabelGrey } from '../validation/Form-Components';
import pData from '../hybriddata/propertydata.json';
import CusRadioG2Btn from '../hybridcomponents/CusRadioG2Btn';
import { decimalValidator, numericValidator, postalCodeValidator, reqDDLValidator, requiredValidator, zeroDecimalValidator } from '../validation/Validators';
import CusRadioButton from '../components/CusRadioButton';
import LocalAddress from '../hybridcomponents/LocalAddress';
import addService from '../services/ApiService';
import LoadingText from '../components/LoadingText';
import Loading from '../components/Loading';
import { useHistory } from "react-router-dom";
import helper from '../factory/Helper';
import storage from '../factory/StorageFactory';
import ForeignAddress from '../hybridcomponents/ForeignAddress';
import service from '../services/PropertyDtlsApiService';
import CusToast from '../components/CusToast';
import { Button } from '@progress/kendo-react-buttons';
import { pdf } from '@progress/kendo-drawing';
import AddBankBalncePopup from '../hybridcomponents/AddBankBalancePopup';
import BankBalanceHistory from '../hybridcomponents/BankBalanceHistory';
import bblistEg from '../hybriddata/bankBalanceListSample.json'
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import currencies from '../hybriddata/currencyList.json';
import pTypes from '../hybriddata/propertyTypes.json';


const PropertyDetails = (props) => {
  
    let timer; 
    const history = useHistory();

    const addressTag='sg', defSgDesc = 'SINGAPORE';
    const numericRegex = new RegExp(/^[0-9]+$/);

    const [isLoading,setIsLoading] = useState(false);
    const [isSearching,setIsSearching] = useState(false);
    const [isSaving,setIsSaving] = useState(false);

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [response,setResponse] = useState();

    const [sgAddTypeResult,setSgAddTypeResult] = useState(null);

    const [selectedRdoTypeOfFinancing,setSelectedRdoTypeOfFinancing] = useState(null);
    const [selectedRdoPurpose,setSelectedRdoPurpose] = useState(null);
    const [selectedRdoPropertyInMind, setSelectedRdoPropertyInMind] = useState(null);

 

    const [initFormData,setInitFormData] = useState({

        propertyTypeCbo:null,  // existing 
        purchasePriceValue:null, //numeric,
       
        sgPostalCode: "", // existing 
        sgBlkNo: "", // existing 
        sgStreet: "", // existing 
        sgStoreyNo: "", // existing 
        sgUnitNo: "", // existing 
        sgBuilding: "", // existing 
        sgLockedBagNo: "", // existing 
        sgGodownNo: "",  // existing 
        sgLotMukimNo:"", // existing 
        sgBoxNo: "", // existing 
        sgPostOffice: "", // existing 
        sgHouseNo: "", // existing 
        sgWindowDeliveryNo: "",// existing 

        city:'', // existing 
        state:'',// existing 
    })

    useEffect(() => {
        console.log('@PropertyDetails useEffect')
        if(helper.isTokenExpired()) {
            props.history.push(config.route.SessionExpired);
            return;
        }
  
        window.scrollTo(0,0);
        getData();
        return () => {
            clearTimeout(timer);
        }
    }, []);

    const getData = () => {
        setIsLoading(true);
        const rno = storage.getRefNo();
        service.get(rno).then( res => {
            if(res.data.isSucess) {
                const resData = res.data.model;
                setResponse(resData);
                bindFormData(resData);
                setIsLoading(false);
            }
            else{
                setIsLoading(false);
                showErrMsg(config.error.GetApiFailed);
            }
        })
        .catch(err=>{
            console.log('err: ',err);
            setIsLoading(false);
         
            return;
        })
    }

    const bindFormData = (data) => {
        let purposeValue = null, propInMindValue = null,propertyTypeCboValue = null;
        let latestOutLoanAmtValue=null, purPriceValue = null;

        const typeOfFinanceValue = (data.typeOfFinance !== '')?data.typeOfFinance:null;
     
        if(typeOfFinanceValue === pData.typeOfFinanceRdo.firstValue) { //New Purchase
            purposeValue = data.purpose;
            propInMindValue = data.propertyInMind;
            if(propInMindValue === 'Y') {
                propertyTypeCboValue = {value:data.propertyType,label: data.propertyTypeDescription};
                purPriceValue = (data.purchasePrice !=='' && data.purchasePrice !==null)?parseFloat(data.purchasePrice):null;
            }
        }
        else { //Refinance
            latestOutLoanAmtValue = (data.latestOutstandingLoanAmt !== '' && data.latestOutstandingLoanAmt !==null)?parseFloat(data.latestOutstandingLoanAmt):null;
        }
   
        setSelectedRdoTypeOfFinancing(typeOfFinanceValue);
        setSelectedRdoPurpose(purposeValue);
        setSelectedRdoPropertyInMind(propInMindValue);
        setSgAddTypeResult(data.addressType !==''?data.addressType:null);

        setInitFormData({
            propertyTypeCbo:propertyTypeCboValue,  // existing 
            purchasePriceValue:purPriceValue, //numeric,
            latestOutLoanAmtValue:latestOutLoanAmtValue,
            sgPostalCode: data.postal_Code, // existing 
            sgBlkNo: data.block_Number, // existing 
            sgStreet: data.street_Name, // existing 
            sgStoreyNo: data.storey_Number, // existing 
            sgUnitNo: data.unit_Number, // existing 
            sgBuilding: data.building_Name, // existing 
            sgLockedBagNo: data.locked_Bag_Number, // existing 
            sgGodownNo: data.godown_Number,  // existing 
            sgLotMukimNo:data.lot_Mukim_Number, // existing 
            sgBoxNo: data.box_Number, // existing 
            sgPostOffice: data.post_Office_Name, // existing 
            sgHouseNo: data.house_Number, // existing 
            sgWindowDeliveryNo: data.window_Delivery_Number,// existing 
    
            city:data.city, // existing 
            state:data.state,// existing 
           
        })
      
    }
    const handleSubmit = (dataItem) => {

        if(dataItem.isValid) {
            let data = JSON.parse(JSON.stringify(dataItem.values));
            storage.setIsAIPSubmission('N'); //no pure aip submission
            if(!isValidRdoFieldsHybrid()) {
                //DO NTH
                return;
            }
            const params = formatHybridJsonParams(data);
            // console.log('HYBRID formatJsonParams: ',params);
            savePropertyDetails(params);
        }
        else {
            showErrMsg(pData.error.inputFields);
        }
    }

    const savePropertyDetails = (params) => {
        setIsSaving(true);
        service.post(params).then(res => {    
            setIsSaving(false);
            if(res.data.isSucess) {
                goNext();
            }  
            else {
                showErrMsg(config.error.SaveApiFailed);
            } 
        }).catch(err => {
            console.log('err: ',err);
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        })
    }

    let formatHybridJsonParams = function(data) {

        let typeOfFinCode= '',typeOfFinDesc='';
        let purposeCode='',purposeDesc = '';
        let latestOutLoanAmt=null;
        let propInMindCode = '',propInMindDesc='';
        let propType = '', prodTypeDesc='';
        let purPrice = null;
        let isLeaseholdCode = '',isLeaseholdDesc='';
        let leaseHoldEffDateValue=null, origLeaseHoldCode='', origLeaseHoldDesc='',origLeaseHoldOth='';
        let postalCode = '',addType = null;
        let isSixMonthsBankBalWithMaybankCode = '', isSixMonthsBankBalWithMaybankDesc = '';
        let isActiveBizAcctWithOtherBanksCode = '', isActiveBizAcctWithOtherBanksDesc = '';
        let bankBalDtlsArray = [],monthlyDebtCommitArray = [];
        let latestAnnIntExpCCY='',latestAnnIntExpAmt=null;
        let latestAnnIntDepOrAmortCCY='',latestAnnIntDepOrAmortAmt=null;
        let isRefinance=false;
 
        postalCode = data.sgPostalCode;
        addType = sgAddTypeResult;
 
        if(selectedRdoTypeOfFinancing !== null){
            if(selectedRdoTypeOfFinancing === pData.typeOfFinanceRdo.firstValue){ //NEW PURCHASE
                typeOfFinCode = pData.typeOfFinanceRdo.firstValue;
                typeOfFinDesc = pData.typeOfFinanceRdo.firstValueLbl;
            }
            else { //REFINANCE
                typeOfFinCode = pData.typeOfFinanceRdo.secValue;
                typeOfFinDesc = pData.typeOfFinanceRdo.secValueLbl;
                latestOutLoanAmt = data.latestOutLoanAmtValue;
                isRefinance = true;
            }
        }

        if(selectedRdoPurpose !== null) {
            if(selectedRdoPurpose === pData.purposePropertyRdo.firstValue){
                purposeCode = pData.purposePropertyRdo.firstValue;
                purposeDesc = pData.purposePropertyRdo.firstValueLbl;
            }
            else {
                purposeCode = pData.purposePropertyRdo.secValue;
                purposeDesc = pData.purposePropertyRdo.secValueLbl;
            }
        }

        if(selectedRdoPropertyInMind !== null) {
            if(selectedRdoPropertyInMind === pData.propertyInMindRdo.leftValue){ //Y
                propInMindCode = pData.propertyInMindRdo.leftValue;
                propInMindDesc = pData.propertyInMindRdo.leftValueLbl;
                propType = data.propertyTypeCbo !==null ? data.propertyTypeCbo.value:'';
                prodTypeDesc = data.propertyTypeCbo !==null ? data.propertyTypeCbo.label:'';
                purPrice = data.purchasePriceValue !==null? data.purchasePriceValue:null
            }
            else { //N
                propInMindCode = pData.propertyInMindRdo.rightValue;
                propInMindDesc = pData.propertyInMindRdo.rightValueLbl;
                propType = '';
                prodTypeDesc = '';
                purPrice = null;
                addType = null;
            }
        }
        
        let params = {
            // stateId:storage.getStateId(),
            referenceNo: storage.getRefNo(),
            typeOfFinance: typeOfFinCode,
            typeOfFinanceDescription: typeOfFinDesc,
            latestOutstandingLoanAmt:latestOutLoanAmt,
            purpose:purposeCode, //existing
            purposeDescription:purposeDesc, //existing
            propertyInMind: propInMindCode,
            propertyInMindDescription: propInMindDesc,
            propertyType:propType, //existing
            propertyTypeDescription: prodTypeDesc, //existing
            purchasePrice:purPrice, //existing
            isLeaseHold: isLeaseholdCode,
            isLeaseHoldDescription: isLeaseholdDesc,
            leaseHoldEffDate:leaseHoldEffDateValue,
            originalLeaseHold: origLeaseHoldCode,
            originalLeaseHoldDescription: origLeaseHoldDesc,
            originalLeaseHoldOthers: origLeaseHoldOth,
             
            builtInArea: '' , //remove
            builtInAreaType: '' , //remove
            builtInAreaTypeDescription: '', //remove
            propertyStatus:'', //remove
            propertyStatusDescription:'', //remove
            refinance:'', //remove
            refinanceDescription:'', //remove
   
            propertyAddress:'', //remove
            propertyAddressDescription:'', //remove

            country: sgAddTypeResult !==null? 'SG':'', //existing, default will pass 'SG'

            postal_Code: (isRefinance || propInMindCode === 'Y')? postalCode:'',  //existing
            addressType:  (isRefinance || propInMindCode === 'Y')? addType:'', //existing

            block_Number:  (isRefinance || propInMindCode === 'Y')? data.sgBlkNo:'', //existing
            street_Name:  (isRefinance || propInMindCode === 'Y')? data.sgStreet:'',//existing
            storey_Number:  (isRefinance || propInMindCode === 'Y')? data.sgStoreyNo:'',//existing
            unit_Number:  (isRefinance || propInMindCode === 'Y')? data.sgUnitNo:'',//existing
            building_Name: (isRefinance || propInMindCode === 'Y')? data.sgBuilding:'', //existing
            godown_Number:  (isRefinance || propInMindCode === 'Y')? data.sgGodownNo:'', //existing
            lot_Mukim_Number:  (isRefinance || propInMindCode === 'Y')? data.sgLotMukimNo:'', //existing
            box_Number: (isRefinance || propInMindCode === 'Y')?data.sgBoxNo:'', //existing
            locked_Bag_Number:  (isRefinance || propInMindCode === 'Y')?data.sgLockedBagNo:'', //existing
            post_Office_Name: (isRefinance || propInMindCode === 'Y')?data.sgPostOffice:'', //existing
            house_Number:  (isRefinance || propInMindCode === 'Y')?data.sgHouseNo:'', //existing
            window_Delivery_Number: (isRefinance || propInMindCode === 'Y')?data.sgWindowDeliveryNo:'', //existing
           
            address_Line1:'',  //remove
            address_Line2: '', //remove 
            address_Line3: '', //remove
 
            city: data.city, //existing
            state: data.state, //existing

            isSixMonthsBankBalWithMaybank:isSixMonthsBankBalWithMaybankCode,
            isSixMonthsBankBalWithMaybankDescription: isSixMonthsBankBalWithMaybankDesc,

            isActiveBizAcctWithOtherBanks: isActiveBizAcctWithOtherBanksCode,
            isActiveBizAcctWithOtherBanksDesc: isActiveBizAcctWithOtherBanksDesc,

            bankBalanceDetails:bankBalDtlsArray,
            monthlyDebtCommitments: monthlyDebtCommitArray,

            latestAnnualIntrestExpense:latestAnnIntExpAmt,
            latestAnnualIntrestExpenseCurrency:latestAnnIntExpCCY,
    
            latestAnnualDepreciationOrAmortisationAmt:latestAnnIntDepOrAmortAmt,
            latestAnnualDepreciationOrAmortisationAmtCurrency:latestAnnIntDepOrAmortCCY
        }

        return params;
    }

  const isValidRdoFieldsHybrid = () => {
        // console.log('isValidRdoFieldsHybrid: ', sgAddTypeResult)
        let isValid = true;
        if(selectedRdoTypeOfFinancing === null) { //type of financing empty
            isValid = false;
            showErrMsg(pData.error.rdoRefinance);
            return;
        }
        //selectedRdoTypeOfFinancing !== null, check rdoPurpose
        if(selectedRdoTypeOfFinancing === pData.typeOfFinanceRdo.firstValue) { //NEw purchase
            if(selectedRdoPurpose === null) {
                isValid = false;
                showErrMsg(pData.error.rdoPurpose);
                return;
            }
            //selectedRdoPurpose !== null, check rdoPropertyInMind
            if(selectedRdoPropertyInMind === null) { //Y
                isValid = false;
                showErrMsg(pData.error.rdoPropertyInMind);
                return;
            }
    
            //selectedRdoPropertyInMind !== null, check selectedRdoPropertyInMind is Y && address search AddType
            if(selectedRdoPropertyInMind === 'Y' && sgAddTypeResult === null) {
                isValid = false;
                showErrMsg(pData.error.invalidAddType);
                // console.log('showAddErr1')
                return;
            }
        }
        else { //REfinance
            if(sgAddTypeResult === null) {
                // console.log('showAddErr2')
                isValid = false;
                showErrMsg(pData.error.invalidAddType);
                return;
            }
        }

        return isValid;
    }
    
    const showPropAddressSection = () => {
        let isShow = false;
        if(selectedRdoTypeOfFinancing === null) {
            isShow = false;
        }
        else {
            if(selectedRdoTypeOfFinancing === pData.typeOfFinanceRdo.secValue){ //refinancing
                isShow = true;
            }
            else if(selectedRdoPropertyInMind === 'Y'){
                isShow = true;
            }
            else {
                isShow = false;
            }
        }
       
        return isShow;
    }

    const resetFormFields = () => {
        setSgAddTypeResult(null);
        setSelectedRdoPurpose(null);
        setSelectedRdoPropertyInMind(null);
        setInitFormData({
            propertyTypeCbo:null,  // existing 
            purchasePriceValue:null, //numeric,
            latestOutstandingLoanAmt:null,
            sgPostalCode: "", // existing 
            sgBlkNo: "", // existing 
            sgStreet: "", // existing 
            sgStoreyNo: "", // existing 
            sgUnitNo: "", // existing 
            sgBuilding: "", // existing 
            sgLockedBagNo: "", // existing 
            sgGodownNo: "",  // existing 
            sgLotMukimNo:"", // existing 
            sgBoxNo: "", // existing 
            sgPostOffice: "", // existing 
            sgHouseNo: "", // existing 
            sgWindowDeliveryNo: "",// existing 

            city:'', // existing 
            state:'',// existing 
        })
    }

     // RADIO BUTTONS SECTION - START
    const handleTypeOfFinanceRdoChange = (e) => {
        setSelectedRdoTypeOfFinancing(e.value);
        if(e.value !== null) { //REFINANCING
            resetFormFields();
        }
    }
    
    const handleRdoGroupPurposeChange = (e) => {
        setSelectedRdoPurpose(e.value);
    }
    
    const handleRdoPropertyInMindChange = (e) => {
        setSelectedRdoPropertyInMind(e.value);
        // resetFormFields();
    }
    // RADIO BUTTONS SECTION - END

    const handleBack = (e) => {
        e.preventDefault();
  
        history.push(config.route.NSPersonDetails);
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }
  
    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            history.push(config.route.DeclarationsDetails);
        }
    }

    // MAILING ADDRESS SEARCH SECTION - START
       
    const getAddressbyPostalCode = (postalCode,formProps) => {
      
        setIsSearching(true);
        
        addService.getAddress(postalCode).then(res=>{

            let data = res.data.model;
            let resdata = data[0];
            let addTypeCode = '';
            if(resdata.addR_TYP_CODE === '' || resdata.addR_TYP_CODE === undefined || resdata.addR_TYP_CODE === null) {
                if(resdata.addR_FMT_CODE === '' || resdata.addR_FMT_CODE === undefined || resdata.addR_FMT_CODE === null) {
                  addTypeCode = config.AddType.Local;
                }
                else {
                  addTypeCode = resdata.addR_FMT_CODE;
                }
            }
            else {
                addTypeCode = resdata.addR_TYP_CODE;
            }
         
            setSgAddTypeResult(addTypeCode);

            checkLocalAddStatus(formProps,addTypeCode,resdata,addressTag);
        })
        .catch(err=>{
            setIsSearching(false);
            console.log('err: ',err);
            resetAddressFields(formProps,addressTag);
            showErrMsg(config.error.GetApiFailed);
            return;
        })
    }


    const checkLocalAddStatus = (fProps,addTypeCodeResult,resdata,tag) => {

        let addTypeCode , blkno='', building='', street='', stCityName = '',poBox ='',unitNo='',storeyNo='';
        let postOfficeName='', lockedBagNo='', goDownNo='', houseNo='', winDeliNo='', lotMukimNo='';
        
        addTypeCode = addTypeCodeResult;
        if(resdata.blK_NO === '' || resdata.blK_NO === undefined || resdata.blK_NO === null) {
            blkno = '';
            lockedBagNo = '';
            goDownNo = '';
            winDeliNo = '';
            houseNo = '';
            lotMukimNo = '';
        }
        else {
            if(addTypeCode === config.addTypeMultiStorery){    //H
                blkno = resdata.blK_NO;
            }
            else if(addTypeCode === config.addTypeLockedBag) { //B
                lockedBagNo = resdata.blK_NO;
            }
            else if(addTypeCode === config.addTypeGodown) { //G
                goDownNo = resdata.blK_NO;
            }
            else if(addTypeCode === config.addTypeWindowDeli) { //W
                winDeliNo =  resdata.blK_NO;
            }
            else if(addTypeCode === config.addTypeHouseShopWalkupApmt) {//S
                houseNo = resdata.blK_NO;
            }
            else if (addTypeCode === config.addTypeLotMukim) { //L
                lotMukimNo = resdata.blK_NO;
            }  
        }

        if(resdata.bldG_NAME === '' || resdata.bldG_NAME === undefined || resdata.bldG_NAME === null) {
            building = '';
        }
        else {
            if(addTypeCode === config.addTypeGodown || addTypeCode === config.addTypeMultiStorery || addTypeCode === config.addTypeHouseShopWalkupApmt) {//G,H,S
                building = resdata.bldG_NAME;
            }
            else if(addTypeCode === config.addTypeLockedBag || addTypeCode === config.addTypePObox || config.addTypeWindowDeli) {//B,P,W
                postOfficeName = resdata.bldG_NAME;
            }
        }

        if(resdata.poboX_NO === '' || resdata.poboX_NO === undefined || resdata.poboX_NO === null) {
            poBox = '';
        }
        else {
            poBox = resdata.poboX_NO;
        }

        if(resdata.sT_NAME === '' || resdata.sT_NAME === undefined || resdata.sT_NAME === null) {
            street = '';
        }
        else {
            if(addTypeCode === config.addTypeGodown || addTypeCode === config.addTypeMultiStorery 
            ||addTypeCode === config.addTypeHouseShopWalkupApmt || addTypeCode === config.addTypeLotMukim) {//G,H,S,L
                street = resdata.sT_NAME;
            }
            else {
                street = '';
            }
        }

        if(resdata.staT_CITY_NAME === '' || resdata.staT_CITY_NAME === undefined || resdata.staT_CITY_NAME === null) {
            stCityName = defSgDesc;
        }
        else {
            stCityName = resdata.staT_CITY_NAME;
        }

        if(resdata.uniT_NO === '' || resdata.uniT_NO === undefined || resdata.uniT_NO === null) {
            unitNo = '';
        }
        else if(addTypeCode === config.addTypeGodown || addTypeCode === config.addTypeMultiStorery) {//G,H
            unitNo = resdata.uniT_NO;
        }

        if(resdata.strY_NO === '' || resdata.strY_NO === undefined || resdata.strY_NO === null) {
            storeyNo = '';
        }
        else {
            storeyNo = resdata.strY_NO;
        }
 
        fProps.onChange(tag+"BlkNo", {
          value: blkno,
        });
        fProps.onChange(tag+"Building", {
          value: building,
        });
        fProps.onChange(tag+"StoreyNo", {
          value: storeyNo,
        });
        fProps.onChange(tag+"UnitNo", {
          value: unitNo,
        });
        fProps.onChange(tag+"Street", {
          value: street,
        });
        fProps.onChange(tag+"LockedBagNo", {
          value: lockedBagNo,
        });
        fProps.onChange(tag+"GodownNo", {
          value: goDownNo,
        });
        fProps.onChange(tag+"LotMukimNo", {
          value: lotMukimNo,
        });
        fProps.onChange(tag+"BoxNo", {
          value: poBox,
        });
        fProps.onChange(tag+"PostOffice", {
          value: postOfficeName,
        });
        fProps.onChange(tag+"HouseNo", {
          value: houseNo,
        });
        fProps.onChange(tag+"WindowDeliveryNo", {
          value: winDeliNo,
        });

        // console.log('street',fProps.valueGetter(tag+'Street'))
        setIsSearching(false);
    }

    const resetAddressFields = (fProps,tag) => {
        fProps.onChange('sgPostalCode',{
            value:''
        });
        fProps.onChange(tag+"BlkNo", {
            value: '',
          });
          fProps.onChange(tag+"Building", {
            value: '',
          });
          fProps.onChange(tag+"StoreyNo", {
            value: '',
          });
          fProps.onChange(tag+"UnitNo", {
            value: '',
          });
          fProps.onChange(tag+"Street", {
            value: '',
          });
          fProps.onChange(tag+"LockedBagNo", {
            value: '',
          });
          fProps.onChange(tag+"GodownNo", {
            value: '',
          });
          fProps.onChange(tag+"LotMukimNo", {
            value: '',
          });
          fProps.onChange(tag+"BoxNo", {
            value: '',
          });
          fProps.onChange(tag+"PostOffice", {
            value: '',
          });
          fProps.onChange(tag+"HouseNo", {
            value: '',
          });
          fProps.onChange(tag+"WindowDeliveryNo", {
            value: '',
          });
      }

    // MAILING ADDRESS SEARCH SECTION - END
    
    if(isLoading) {
        return(
          <Loading />
        )
    }

    return(
        <div className="container-fluid">
            <SubHeader title={config.Branding.title} img={headerImg}/> <br/>
            <Form
                onSubmitClick={handleSubmit} 
                initialValues={initFormData}
                key={JSON.stringify(initFormData)}
                render={(formRenderProps) => (
                    <FormElement>
                        <FormContainer>
                            <fieldset>
                                <FieldWrapper>
                                    <Field component={FormTitleHybrid} id={'ft1'} name={pData.mainTitle}/>
                                </FieldWrapper>
                            
                                <FieldWrapper>
                                    <CusRadioG2Btn 
                                        name="rdoGroupTypeOfFinance" 
                                        firstValue={pData.typeOfFinanceRdo.firstValue} 
                                        secValue={pData.typeOfFinanceRdo.secValue} 
                                        label={pData.label.typeOfFinance} 
                                        firstValueLabel={pData.typeOfFinanceRdo.firstValueLbl}
                                        secValueLabel={pData.typeOfFinanceRdo.secValueLbl}
                                        onChange={handleTypeOfFinanceRdoChange} 
                                        checkedValue={selectedRdoTypeOfFinancing} />   
                                </FieldWrapper>

                                {/* NEW_PURCHASE -START */}
                                {selectedRdoTypeOfFinancing === pData.typeOfFinanceRdo.firstValue &&
                                <>
                                    <FieldWrapper>
                                        <CusRadioG2Btn 
                                            name="rdoGroupPurpose" 
                                            firstValue={pData.purposePropertyRdo.firstValue} 
                                            secValue={pData.purposePropertyRdo.secValue} 
                                            label={pData.label.purpose} 
                                            firstValueLabel={pData.purposePropertyRdo.firstValueLbl}
                                            secValueLabel={pData.purposePropertyRdo.secValueLbl}
                                            onChange={handleRdoGroupPurposeChange} 
                                            checkedValue={selectedRdoPurpose} />   
                                    </FieldWrapper>
                                    {/* rdoPropertyInMind SECTION - Applied HYBRID & AIP, selectedRdoPurpose !== null */}
                                    {(selectedRdoPurpose !== null)&&
                                    <FieldWrapper>
                                        <CusRadioButton name="rdoPropertyInMind" 
                                            leftValue={pData.propertyInMindRdo.leftValue} rightValue={pData.propertyInMindRdo.rightValue} disabled={false}
                                            leftValueLabel={pData.propertyInMindRdo.leftValueLbl} rightValueLabel={pData.propertyInMindRdo.rightValueLbl}
                                            label={pData.label.propertyInMind} labelDesp={''}
                                            onChange={handleRdoPropertyInMindChange} 
                                            checkedValue={selectedRdoPropertyInMind} />
                                    </FieldWrapper>
                                    }
                                    {selectedRdoPropertyInMind === 'Y' &&
                                    <FieldWrapper>
                                        
                                        <Field leftLabelId={'lblPropertyType'} 
                                            leftLabelName={pData.label.propertyType}
                                            id={'propertyTypeCbo'} 
                                            name={'propertyTypeCbo'}
                                            component={CusFormComboBox} 
                                            textField={'label'}
                                            disabled={false}
                                            data={pTypes} 
                                            placeholder={'Please select'} 
                                            validator={reqDDLValidator} />

                                        <Field component={CusFormNumericTextBox} 
                                            leftLabelId={'lblPurchasePrice'} leftLabelName={pData.label.purchasePrice} 
                                            id={'purchasePriceValue'} 
                                            name={'purchasePriceValue'} 
                                            placeholder={'S$0'}
                                            validator={decimalValidator}
                                            spinners={false} 
                                            format="c2"
                                            />
                                    </FieldWrapper>
                                    }
                                </>
                                }
                                {selectedRdoTypeOfFinancing === pData.typeOfFinanceRdo.secValue &&
                             
                                <Field component={CusFormNumericTextBox} 
                                    leftLabelId={'lblLatestOutLoanAmt'} 
                                    leftLabelName={pData.label.latestOutLoanAmt} 
                                    id={'latestOutLoanAmtValue'} 
                                    name={'latestOutLoanAmtValue'} 
                                    placeholder={'S$0'}
                                    validator={zeroDecimalValidator}
                                    spinners={false} 
                                    format="c2"
                                />
                            
                                }
                            </fieldset>
                            <br/>
                        </FormContainer>
                        {/* PROPERT ADDRESS SECTION - START */}
                        {(showPropAddressSection())&&
                        <FormContainer>
                            <fieldset>
                            <FieldWrapper>
                                <Field component={FormTitleTooltip} id={'ft2'} name={pData.formTitle.ft2}
                                    tooltipPosition={'right'} tooltipAchor={'target'} 
                                    tooltipTitle={pData.tooltipText.ft2}
                                />
                            </FieldWrapper>
  
                            <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box" style={{ marginTop: "5px" }}>{pData.label.PostalCode}</div>
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div style={{width:'90%', float:'left'}}>
                                            <Field className="k-textbox" name={'sgPostalCode'} id={'sgPostalCode'}
                                                placeholder={'eg. 569083'} 
                                                maxLength={6} 
                                                component={FormInput} 
                                                validator={postalCodeValidator} 
                                                onKeyDown={e => {
                                                    if(e.keyCode === 13) {
                                                        e.preventDefault();
                                                
                                                        let postalCode = formRenderProps.valueGetter('postal_Code');
                                                    
                                                        getAddressbyPostalCode(postalCode,formRenderProps);
                                                    }
                                                }}
                                                />
                                        </div>
                                        <div style={{width:'10%', float:'left', textAlign:'center',paddingLeft:'5px'}}>
                                            <a className="k-icon k-i-zoom" style={{fontSize:'22px'}} onClick={(e)=>{
                                                e.preventDefault();
                               
                                                let postCode = formRenderProps.valueGetter('sgPostalCode');
                                                if(postCode === '' || postCode === undefined) {
                                                    return;
                                                }
                                                else if(postCode.length > 6 || !numericRegex.test(postCode) ) {
                                                    return;
                                                }
                                              
                                                getAddressbyPostalCode(postCode,formRenderProps);

                                                }}>
                                            </a>
                                            <div style={{fontSize:'10px'}} >Search</div>
                                        </div>
                                    </div>
                                </div>

                                <LocalAddress id={addressTag} addressType={sgAddTypeResult} />
                         
                            </FieldWrapper>
                             
                            </fieldset>
                            <br/>
                        </FormContainer>
                        }
                        <FormContainer>
                            <div style={{paddingTop:'20px',paddingBottom:'20px'}}>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <Button type={'submit'} className="k-button btn btnMargin btn-success btn-float-right"
                                            disabled={false}>{config.btnName.Next}</Button>
                                        <Button type={'button'} style={{border:'1px solid #343a40'}} className="k-button btn btnMargin btn-back" onClick={handleBack}>{config.btnName.Back}</Button>
                                    </div>
                                </div>                            
                            </div>
                        </FormContainer>  
                        <br/>
                    </FormElement>
            )}></Form>
            <LoadingText show={isSearching} setShow={setIsSearching} label={'Please wait..'} />
            {isSaving && <Loading />}
            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer}  /> 
        </div>
    )
}

export default PropertyDetails;